import { Button, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { useGetUserCapturedPropertyDetailsQuery } from '@client/graphql/__generated__/main-operations';
import { PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { PropertyDetailsCard } from '../ListingCard/PropertyDetailsCard';
import { AddOffMarketListingModal } from './AddOffMarketListing/AddOffMarketListingModal';

export const OffMarketListings = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useGetUserCapturedPropertyDetailsQuery();

  const propertyDetails = data?.getUserCapturedPropertyDetails;

  return (
    <VStack alignItems="flex-start" gap={4}>
      <HStack alignItems="center" gap={4}>
        <Text fontSize="xl" fontWeight="medium">
          Off Market Listings
        </Text>
        <Button
          leftIcon={<Icon as={PlusIcon} boxSize="14px" />}
          size="xs"
          onClick={() => setIsOpen(true)}
        >
          Add
        </Button>
      </HStack>

      <HStack gap={2} overflowX="auto" width="100%">
        {propertyDetails?.map((property) => (
          <PropertyDetailsCard key={property.id} propertyDetails={property} />
        ))}
      </HStack>

      <AddOffMarketListingModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </VStack>
  );
};
